<script lang="ts">
  const effectiveDate = "2026년 7월 16일";
</script>

<svelte:head>
  <title>이용약관 | TripHelper</title>
</svelte:head>

<div
  class="min-h-screen bg-app px-4 py-10"
  style="word-break: keep-all; overflow-wrap: break-word;"
>
  <div class="w-full max-w-2xl mx-auto">
    <div class="card">
      <h1 class="text-2xl font-bold text-primary">이용약관</h1>
      <p class="text-sm text-muted mt-2">시행일: {effectiveDate}</p>

      <div class="mt-8 space-y-8 text-sm text-secondary leading-relaxed">
        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제1조 (목적)
          </h2>
          <p>
            이 약관은 Dcode(이하 "운영자")가 제공하는 TripHelper
            서비스(이하 "서비스")의 이용과 관련하여 운영자와
            이용자의 권리, 의무 및 책임 사항을 정하는 것을
            목적으로 합니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제2조 (정의)
          </h2>
          <ul class="list-disc list-inside space-y-1">
            <li>"서비스"란 여행 기록·계획·정산을 지원하는 TripHelper 앱 및 웹을 말합니다.</li>
            <li>
              "이용자"란 이 약관에 따라 서비스를 이용하는 회원 및
              게스트를 말합니다.
            </li>
            <li>
              "공유 여행"이란 둘 이상의 이용자가 함께 사용하는
              여행 데이터를 말합니다.
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제3조 (계정 및 로그인)
          </h2>
          <p>
            서비스는 1Pass(logi) SSO를 통해 계정을 식별합니다.
            이용자는 본인의 계정 정보를 안전하게 관리할 책임이
            있으며, 계정 정보 유출로 인해 발생한 손해에 대해
            운영자는 고의 또는 중대한 과실이 없는 한 책임을 지지
            않습니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제4조 (서비스 이용)
          </h2>
          <p>
            이용자는 개인 여행 기록을 로컬 기기에 저장하거나,
            공유 여행 기능을 통해 다른 이용자와 함께 여행 정보를
            관리할 수 있습니다. 운영자는 서비스의 안정적인 제공을
            위해 노력하나, 서비스 내용이 변경되거나 일시 중단될
            수 있습니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제5조 (금지행위)
          </h2>
          <ul class="list-disc list-inside space-y-1">
            <li>타인의 계정 또는 개인정보를 도용하는 행위</li>
            <li>서비스의 정상적인 운영을 방해하는 행위</li>
            <li>법령 또는 공서양속에 위반되는 정보를 게시하는 행위</li>
            <li>서비스를 이용해 타인에게 피해를 주는 행위</li>
          </ul>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제6조 (책임의 한계)
          </h2>
          <p>
            운영자는 천재지변, 이용자의 귀책사유 등 운영자가
            통제할 수 없는 사유로 발생한 서비스 장애에 대해서는
            책임을 지지 않습니다. 이용자가 직접 입력한 AI API 키를
            통해 발생하는 외부 AI 서비스 이용 결과에 대해서도
            운영자는 책임을 지지 않습니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            제7조 (준거법 및 관할)
          </h2>
          <p>
            이 약관은 대한민국 법령에 따라 규율되며, 서비스
            이용과 관련해 분쟁이 발생하는 경우 관계 법령이 정한
            절차에 따릅니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            문의처
          </h2>
          <p>
            이용약관 관련 문의는 <a
              href="mailto:support@1pass.dev"
              class="text-accent underline">support@1pass.dev</a
            >로 연락해 주시기 바랍니다.
          </p>
        </section>
      </div>

      <a
        href="/"
        class="block mt-10 text-sm text-muted hover:text-secondary transition-colors duration-200"
      >
        홈으로 돌아가기
      </a>
    </div>
  </div>
</div>
